export default function initializeStickyHeader() {
    const header = document.getElementById('site-header');
    if (!header) return;

    let threshold = 10;
    let ticking = false;

    const topRow = header.querySelector('.header__top-row');
    if (topRow) {
        threshold = topRow.offsetHeight;
    }

    // Hysteresis gap so the collapsing/expanding top row (which shrinks the
    // sticky header's height and can nudge scrollY via scroll anchoring)
    // doesn't cross the same threshold again and re-trigger the toggle.
    // Must be >= threshold: the top row collapse changes header height by
    // up to `threshold` px, so a smaller gap lets that shift alone push
    // scrollY back across (threshold - hysteresis) and flip the class again.
    const hysteresis = Math.max(24, threshold);

    // Exposed so anchor targets (e.g. category jump links) can offset
    // themselves by `scroll-margin-top: var(--header-height)` instead of
    // scrolling to right under the sticky header.
    function updateHeaderHeightVar() {
        document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    }

    function onScroll() {
        const isSticky = header.classList.contains('is-sticky');
        if (!isSticky && window.scrollY > threshold) {
            header.classList.add('is-sticky');
        } else if (isSticky && window.scrollY <= Math.max(0, threshold - hysteresis)) {
            header.classList.remove('is-sticky');
        }
        updateHeaderHeightVar();
        ticking = false;
    }

    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(onScroll);
            ticking = true;
        }
    }, { passive: true });

    window.addEventListener('resize', () => {
        if (!header.classList.contains('is-sticky') && topRow) {
            threshold = topRow.offsetHeight;
        }
        updateHeaderHeightVar();
    }, { passive: true });

    updateHeaderHeightVar();
}
